import React from 'react'
import './ImageDownload.css'

function ImageDownload(props) {
    // Props: title, defaultImage, largeImage, largeImageSize
    var imageSize = props.fileSize;

    return ( 
        <>
        <div className='imageDownload'>
            {/* <h4>{props.title}</h4> */}
            <img src={require('./../data/'+ props.defaultImage)} alt={props.title} />
            <br />
            <caption>{props.title} <a className='imageDownloadButton' href={require('./../data/'+ props.largeImage)} target="_blank" rel="noreferrer">Bekijk PDF-versie ({imageSize})</a></caption> 
        </div>
        </>
    )
}

export default ImageDownload 